<template>
    <aside>
        <div class="section-data my-3" style="min-height: 400px;">
            <div class="title d-flex justify-content-between">
                <div class="text">
                    <div id="slot-title">
                    </div>
                    <h3 class="font-blue">Candidatos</h3>
                    <p class="font-gray-dark">Selecciona un candidato para ver su información profesional</p>
                </div>
                <div class="tools">
                    <div id="slot-tools">
                    </div>
                </div>
            </div>
            <div class="data">
                <div class="container my-3">
                    <div id="slot-content">
                    </div>
                    <div class="content">
                        <div class="my-3">
                            <p class="font-weight-bold h5" style="color:#244076;">Para contactar a los candidatos necesitas una membresía**</p>
                        </div>
                        <b-tabs pills content-class="mt-3" fill >
                            <b-tab v-for="(status,key) in statusPostulation" :key="key" :active="key===0" :title-item-class="isMobile ? 'btn-tab ml-2 p-0 mt-2 border' :  'btn-tab p-0 '">
                                <template slot="title" >
                                    {{ status.name }}
                                </template>
                                <div class="p-0">
                                   <div :class="isMobile ? 'table-responsive' : ''" style="z-index:1;">
                                    <table class="table table-sm table-hover mb-5">
                                        <thead class="b-gray-light border-bottom text-center">
                                        <tr>
                                            <th class="text-center">
                                                <i class="fas fa-medal font-yellow"></i> Match
                                            </th>
                                            <th class="text-left">Candidato</th>
                                            <th>¿Contactar?</th>
                                            <th>Opciones</th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        <CandidateRow
                                                v-for="(candidate, key) in filterByStatus(candidates, status.status)"
                                                :key="key"
                                                :data="candidate"
                                                :isGold="isGold"
                                                :jobId="idJob"/>

                                        <!--<CandidateElement v-for="candidate in candidates" :key="candidate.id" :data="candidate" :jobId="idJob" :isGold="isGold"/>-->
                                        </tbody>
                                    </table>
                                   </div>
                                    <TableEmpty :data="filterByStatus(candidates, status.status)"></TableEmpty>
                                </div>
                            </b-tab>
                        </b-tabs>
                        <br>

                    </div>
                </div>
            </div>
        </div>
    </aside>
</template>
<style lang="scss">
.target {
  margin-top: 0;
}

.section {
  &-data {
    background: #fff !important;
    -webkit-box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
    border-radius: .25rem !important;

    .title {
      padding: 15px 0 0 15px;
      border-bottom: 1px solid #EEEEEE;
    }

    .data {
      .is-empty, .is-loading {
        padding: 45px;
        text-align: center;
        justify-content: center;
        align-content: center;

        img {
          opacity: .5;
        }
      }
    }
  }
}

.btn.dropdown-toggle {
  background: #244076
}


.btn-tab a:not(.active) {
  color: #244076 !important;
  background: transparent !important;
  transition: all 300ms ease;
}

.btn-tab .active {
  color: white !important;
  background: #244076 !important;
  transition: all 300ms ease;
}

.tab-pane {
  padding: 0px !important;
}
</style>
<script>
import CandidateElement from './components/CandidateElement'
import CandidateRow from './components/CandidateRow'

const compare = (a, b) => {
    if (a.match.percentage > b.match.percentage) {
        return -1;
    }
    if (a.match.percentage > b.match.percentage) {
        return 1;
    }
    return 0;
}

export default {
    props: {
        idJob: String,
        candidates: Array,
        matches: Array,
        isGold: Boolean,
    },
    components: {
        'CandidateElement': CandidateElement,
        'CandidateRow': CandidateRow
    },
    data() {
        return {
            // downloading: false,
            // candidates: {},
            isMobile: this.$mobile(),
            statusFilter: 'send',
            statusPostulation: [
                {
                    name: "Nuevos",
                    status: ["send"]
                },
                {
                    name: "Evaluado",
                    status: ["read"]
                },
                {
                    name: "Entrevistado",
                    status: ["interviewed"]
                },
                {
                    name: "Propuesta ofrecida",
                    status: ["negotiation"]
                },
                {
                    name: "Contratados",
                    status: ["aproved"]
                },
                {
                    name: "Rechazados",
                    status: ["declined"]
                }
            ]
        }
    },
    methods: {
        getCandidates(value) {
            this.$parent.loadJob(value)
        },
        filterByStatus(data, status) {
            let dt = data.filter((candidate) => {
                return status.includes(
                    candidate.status.toLowerCase()
                )
            });
            return dt.sort(compare)
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/jobs/pages/CandidatesList.vue